export const VPN_CONNECTION_ERROR_MESSAGE = 'VPN Connection Error';
